import { useEnrichedAttributeListStore } from '../stores/enrichedAttributeListStore';

export const useEnrichedAttributeList = () => {
  const enrichedAttributeList = useEnrichedAttributeListStore(
    (state) => state.enrichedAttributeList
  );
  const setEnrichedAttributeList = useEnrichedAttributeListStore(
    (state) => state.setEnrichedAttributeList
  );
  const clearEnrichedAttributeList = useEnrichedAttributeListStore(
    (state) => state.clearEnrichedAttributeList
  );
  const getEnrichedAttributeList = useEnrichedAttributeListStore(
    (state) => state.getEnrichedAttributeList
  );
  const isEnrichedAttributeListLoaded = useEnrichedAttributeListStore((state) =>
    state.isEnrichedAttributeListLoaded()
  );

  return {
    enrichedAttributeList,
    isLoading: isEnrichedAttributeListLoaded,
    setEnrichedAttributeList,
    clearEnrichedAttributeList,
    getEnrichedAttributeList,
  };
};
